// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { Button, Text } from "../";

type Props = {
  ...PropsFromLocalize,
  active: boolean,
  disabled?: boolean,
  onChange: Function,
  className?: string,
  activeLabel?: string,
  inactiveLabel?: string,
  enabledStyles?: string,
  disabledStyles?: string,
  readonly?: boolean,
  buttonType?: string,
};

const SwitchButton = ({ active, ...props }) => {
  const handleClick = () => {
    props.onChange(!active);
  };

  return (
    <Button
      className={classNames("switch-button", props.className, {
        "button-active": active,
        "button-disabled": props.disabled,
        "read-only": props.readonly,
        [props.enabledStyles]: active && props.enabledStyles,
        [props.disabledStyles]: !active && props.disabledStyles,
      })}
      onClick={!props.disabled ? handleClick : undefined}
      type={props.buttonType || "submit"}
    >
      <div className="switch-button-knob" />
      <Text color="white" size={0.9}>
        {active ? props.activeLabel || props.t("ON") : props.inactiveLabel || props.t("OFF")}
      </Text>
    </Button>
  );
};

export default localize()(SwitchButton);
